import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '@mui/material';
import styled from '@emotion/styled';

const FlexContainer = styled('div') `
  display: flex;
  flex-shrink: 0;
`;
const IconContainer = styled('div') `
  width: 18px;
  height: 18px;
  margin-right: 4px;
`;
const ItemLabel = ({ label, icon, isTitle }) => (jsxs(FlexContainer, { children: [icon && jsx(IconContainer, { children: icon }), jsx(Typography, Object.assign({ variant: isTitle ? 'subtitle2' : 'body1', color: "#D3E8F9" }, { children: label }))] }));

export { ItemLabel };
//# sourceMappingURL=ItemLabel.js.map
